<template>
  <div 
    class="social-network-card" 
    :class="{ 'selected': isSelected }"
    :style="getBorderStyle()"
    @click="$emit('click')"
  >
    <div class="icon-container">
      <b-avatar
        size="48"
        variant="light"
        :class="getBackgroundClass()"
      >
        <b-img 
          :src="getIconWhite(network.value)" 
          :class="getPaddingClass()"
          fluid
        />
      </b-avatar>
    </div>
    <div class="network-name" :style="getTextStyle()">
      {{ network.text }}
    </div>
  </div>
</template>

<script>
import { BImg, BAvatar } from 'bootstrap-vue'
import { getIconWhite, getIconColor } from '@/libs/utils/icons'

export default {
  name: 'CardSocialNetwork',
  components: {
    BImg,
    BAvatar
  },
  props: {
    network: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getIconWhite,
    getIconColor,
    getBorderStyle() {
      if (!this.isSelected) {
        return {
          borderColor: '#e9ecef'
        }
      }
      
      const colors = {
        'instagram': '#E4405F',
        'tiktok': '#000000',
        'twitch': '#9146FF',
        'facebook': '#1877F2',
        'linkedin': '#0A66C2',
        'spotify': '#1DB954',
        'telegram': '#0088CC',
        'youtube': '#FF0000',
        'twitter': '#1DA1F2',
        'snapchat': '#FFFC00',
        'pinterest': '#E60023',
        'blog': '#666666',
        'whatsapp': '#25D366',
        'reddit': '#FF4500'
      }
      
      return {
        borderColor: colors[this.network.value] || '#5582f6',
        borderWidth: '2px'
      }
    },
    getBackgroundClass() {
      return this.network.value
    },
    getPaddingClass() {
      if (this.network.value === 'spotify') {
        return 'padding-03'
      } else if (this.network.value === 'blog') {
        return ''
      } else {
        return 'padding-07'
      }
    },
    getTextStyle() {
      if (!this.isSelected) {
        return { color: '#666666' }
      }

      const colors = {
        'instagram': '#E4405F',
        'tiktok': '#000000',
        'twitch': '#9146FF',
        'facebook': '#1877F2',
        'linkedin': '#0A66C2',
        'spotify': '#1DB954',
        'telegram': '#0088CC',
        'youtube': '#FF0000',
        'twitter': '#1DA1F2',
        'snapchat': '#FFFC00',
        'pinterest': '#E60023',
        'blog': '#666666',
        'whatsapp': '#25D366',
        'reddit': '#FF4500'
      }
      
      const color = colors[this.network.value] || '#5582f6'

      if (this.network.value === 'snapchat') {
        return { color: '#000000' }
      }
      
      return { color }
    }
  }
}
</script>

<style scoped>
.social-network-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  border-radius: 12px;
  border: 2px solid #e9ecef;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 120px;
  position: relative;
}

.social-network-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.social-network-card.selected {
  background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.95));
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.icon-container {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}

.network-name {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s ease;
  line-height: 1.2;
}

.facebook { background-color: #3b5998 !important; }
.instagram { background-color: #d6249f !important; }
.linkedin { background-color: #346297 !important; }
.twitch { background-color: #924DF7 !important; }
.twitter { background-color: #0791ce !important; }
.youtube { background-color: #c4302b !important; }
.tiktok { background-color: #000000 !important; }
.spotify { background-color: #64D862 !important; }
.pinterest { background-color: #E73630 !important; }
.blog { background-color: #00749a !important; }
.snapchat { background-color: #F5D90D !important; }
.telegram { background-color: #0088CC !important; }
.whatsapp { background-color: #25D366 !important; }
.reddit { background-color: #FF4500 !important; }
</style>